import axios from '../helpers/axiosHelper'
import {
    DistrictsApiType,
    UserApiType,
    UsersApiType
} from '../types/apiTypes'



export const userAPI: UserApiType = {
    signIn(loginData) {
        return axios.post('/login', loginData)
    },
    appLogout(){
        return axios.get('/login/logout')
    },
}

export const requestsAPI = {
   getMapRequestsList(){
       return axios.get('/requests')
   },
    getDistricts(){
        return axios.get('/districts')
    },
    getRegions(){
        return axios.get('/regions')
    },
    removeRequestById(id: number){
       return axios.delete(`/requests/${id}`)
    },
    getRequestById(id: number){
       return axios.get(`/requests/${id}`)
    },
    getRequestTopics(){
       return axios.get(`/request-topics`)
    },
    getRequestStatuses(){
        return axios.get(`/request-statuses`)
    },
    getRequestIconTypes(){
        return axios.get(`/request-icon-types`)
    },
    updateRequest(id: number, reqData: any){
        return axios.put(`/requests/${id}`, reqData)
    },
    addRequestPhoto(id: number, reqData: any){
        const headers = {
            'Content-Type': 'multipart/form-data'
        };
       return axios.post(`/requests/${id}/photos`, reqData, {headers})
    },
    removePhotoById(id: number){
        return axios.delete(`/request-photos/${id}`)
    },
    updatePhotoRankOrder(id: number, reqData: {
        "old_index": number,
        "new_index": number
    }){
        return axios.put(`/request-photos/${id}/update-order`, reqData)
    },
    getQuarters(){
       return axios.get(`/quarters`)
    },
    removeRequestComment(id: number){
       return axios.delete(`/request-comments/${id}`)
    },
    updateRequestComment(id: number, reqData: any){
        return axios.put(`/request-comments/${id}`, reqData)
    }
}

export const usersAPI: UsersApiType = {
    getUsers(){
        return axios.get('/users')
    },
    updateUser(id, userData){
        return axios.put(`/users/${id}`, userData)
    },
    updateUserStatus(id, isActive){
        return axios.patch(`/users/${id}/change-status`, {is_active: isActive})
    },
    removeUser(id){
        return axios.delete(`/users/${id}`)
    }
}

export const districtsAPI: DistrictsApiType = {
    getDistricts(){
        return axios.get('/district-objects')
    },
    getDistrictById(id: number){
        return axios.get(`/district-objects/${id}`)
    },
    createDistrict(districtData){
        return axios.post('/district-objects', districtData)
    },
    updateDistrict({id, formValues}){
        return axios.put(`/district-objects/${id}`, formValues)
    },
    deleteDistrict(id){
        return axios.delete(`/district-objects/${id}`)
    }
}
